import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const footerCategories = categories.slice(0, 8);

  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12">

          <div className="lg:col-span-1">
            <Link to="/" className="inline-block mb-6">
              <span className="font-heading text-2xl font-bold text-background-50 tracking-tight">
                CSSBuy<span className="text-primary-400">Sheet</span>
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed mb-6 max-w-xs">
              The most comprehensive CSSBuy Spreadsheet directory. 15K+ verified product finds across 14 categories, updated weekly.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              CSSBuy Sheet
              <i className="ri-arrow-right-up-line text-base"></i>
            </a>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5">Categories</h4>
            <ul className="space-y-3">
              {footerCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">Home</Link></li>
              <li><a href="#categories" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">All Categories</a></li>
              <li><Link to="/article/cssbuy-spreadsheet-guide" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">Complete Guide</Link></li>
              <li><a href="#faq" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">FAQ</a></li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer">
                  Kaspreadsheet Main Site
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-5">Stay Updated</h4>
            <p className="text-sm text-foreground-300 mb-4 leading-relaxed">
              Get notified when new CSSBuy finds drop. Fresh spreadsheet updates every week.
            </p>
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d96dvdfpg5pqhofcuntg"
              method="POST"
              className="flex flex-col gap-3"
            >
              <div className="flex gap-2">
                <input
                  type="email"
                  name="email"
                  placeholder="your@email.com"
                  required
                  className="flex-1 px-4 py-2.5 bg-foreground-800 text-background-50 placeholder:text-foreground-400 rounded-lg text-sm border border-foreground-700 focus:outline-none focus:border-primary-400 transition-colors"
                />
                <button
                  type="submit"
                  className="w-10 h-10 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors flex-shrink-0 cursor-pointer"
                  aria-label="Subscribe"
                >
                  <i className="ri-arrow-right-line text-lg"></i>
                </button>
              </div>
              <input
                type="text"
                name="phone_alt"
                autoComplete="off"
                tabIndex={-1}
                aria-hidden="true"
                readOnly
                className="honeypot-field"
              />
            </form>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 CSSBuy Sheet. All external links point to kaspreadsheet.com. Not affiliated with CSSBuy.
          </p>
          <div className="flex items-center gap-6">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">Privacy</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">Terms</a>
            <Link to="/" className="text-xs text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">Home</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}